import React, { useState } from "react";
import classes from "./adminPanel.module.scss";
import AdminForm from "../../components/AdminForms/AdminForm";
import {
  ButtonTextSizeEnum,
  ButtonVariantEnum,
} from "../../components/Button/button.types";
import Button from "../../components/Button/Button";
import { headerButtonsArray, tabsConstants } from "./constans";
import VideosList from "./VideoList";
import UsersList from "./UsersList";
import FormSwitcher from "./Forms";
import WalletComponent from "./Wallet";
import MerchantCampaignList from "./CampaignsList";
import ScreenForms from "../../components/ScreenForms";
import Insights from "./Insights";
import ControlHub from "./ControlHub";
import Media from "./Media";
import PublicScreens from "./PublicScreens";
import { useSearchParams } from "react-router-dom";

const AdminPanel: React.FC = () => {
  // const [selectedView, setSelectedView] = useState<string>(tabsConstants.videos);
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedView = searchParams.get("tab") ?? tabsConstants.media;

  const renderBody = (selectedView: string): JSX.Element => {
    const tabsComponentMapping: { [key: string]: JSX.Element } = {
      [tabsConstants.videos]: (
        <div className={classes.listContainer}>
          <VideosList />{" "}
        </div>
      ),
      [tabsConstants.media]: (
        <div className={classes.listContainer}>
          <Media />{" "}
        </div>
      ),
      [tabsConstants.screenForm]: (
        <div className={classes.formswitchContainer}>
          <ScreenForms />
        </div>
      ),
      [tabsConstants.userForm]: (
        <div className={classes.formswitchContainer}>
          <AdminForm />
        </div>
      ),
      [tabsConstants.users]: (
        <div className={classes.listContainer}>
          <UsersList />{" "}
        </div>
      ),
      // [tabsConstants.users] : (<div className={classes.listContainer}><UsersList /> </div>),
      [tabsConstants.wallet]: (
        <div>
          <WalletComponent />
        </div>
      ),
      [tabsConstants.campaigns]: (
        <div className={classes.listContainer}>
          <MerchantCampaignList />{" "}
        </div>
      ),
      [tabsConstants.screens]: (
        <div className={classes.listContainer}>
          <PublicScreens />{" "}
        </div>
      ),
      // [tabsConstants.campaigns] : (<div className={classes.listContainer}><MerchantCampaignList /> </div>),
      [tabsConstants.screenCampaignInsights]: (
        <div className={classes.listContainer}>
          <Insights />{" "}
        </div>
      ),
      [tabsConstants.controlHub]: (
        <div className={classes.listContainer}>
          <ControlHub />
        </div>
      ),
    };

    return tabsComponentMapping[`${selectedView}`];
  };

  const handeTabsChange = (view: string) => {
    // setSelectedView((_) => view);
    setSearchParams({ tab: view });
  };

  return (
    <div className={classes.container}>
      <header className={classes.header}>
        {headerButtonsArray.map((button) => (
          <Button
            className={classes.buttonWrapper}
            key={button.view}
            variant={
              selectedView === button.view
                ? ButtonVariantEnum.primary
                : button.variant
            }
            onClick={() => handeTabsChange(button.view)}
            size={ButtonTextSizeEnum.sm}
            text={button.text}
            isActive={selectedView === button.view}
          />
        ))}
      </header>
      <div className={classes.body}>{renderBody(selectedView)}</div>
    </div>
  );
};

export default AdminPanel;
